import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import {
  dismissOrderFeedback,
  snoozeOrderFeedback,
  submitOrderFeedback,
} from '../../actions/orderFeedback.action';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {
  ANALYTICS_EVENTS,
  FEEDBACK_RESULT,
  ORDER_FEEDBACK_COPY,
} from '../../constants/constants';

// Post-delivery "How were your products?" popup for the latest order.
const OrderFeedbackModal = () => {
  const dispatch = useDispatch();
  const orderFeedback = useSelector(state => state.orderFeedback);
  const {
    items,
    orderId,
    submitting,
    result,
    itemErrors,
    alreadyReviewedItemIds,
  } = orderFeedback;

  // Keyed on the order id so the view is counted once per popup. `items` is
  // left out on purpose: it shrinks after a partial submit, which isn't a new
  // view.
  useEffect(() => {
    GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.ORDER_FEEDBACK_VIEW, {
      itemCount: items.length,
    });
  }, [orderId]);

  const onMaybeLater = ratedCount => {
    GoogleAnalyticsHelper.trackEvent(
      ANALYTICS_EVENTS.ORDER_FEEDBACK_MAYBE_LATER,
      {itemCount: items.length, ratedCount}
    );
    dispatch(snoozeOrderFeedback());
  };

  const onClose = ratedCount => {
    if (result !== FEEDBACK_RESULT.SUCCESS) {
      GoogleAnalyticsHelper.trackEvent(
        ANALYTICS_EVENTS.ORDER_FEEDBACK_DISMISS,
        {
          itemCount: items.length,
          ratedCount,
        }
      );
    }
    dispatch(dismissOrderFeedback());
  };

  return (
    <FeedbackModal
      items={items}
      title={ORDER_FEEDBACK_COPY.TITLE}
      subtitle={ORDER_FEEDBACK_COPY.SUBTITLE}
      secondaryLabel={ORDER_FEEDBACK_COPY.MAYBE_LATER}
      onSecondary={onMaybeLater}
      onClose={onClose}
      onSubmit={reviews => dispatch(submitOrderFeedback(reviews))}
      submitting={submitting}
      result={result}
      itemErrors={itemErrors}
      alreadyReviewedItemIds={alreadyReviewedItemIds}
    />
  );
};

export default OrderFeedbackModal;
